<script lang="ts">
  import { onDestroy } from 'svelte';
  import { fade } from 'svelte/transition';
  import {
    disableBodyScroll,
    clearAllBodyScrollLocks,
    enableBodyScroll,
  } from 'body-scroll-lock';

  export let show = false;

  let bodyElement: HTMLElement;

  $: if (bodyElement) {
    show ? disableBodyScroll(bodyElement) : enableBodyScroll(bodyElement);
  }

  onDestroy(() => {
    clearAllBodyScrollLocks();
  });

  // todo: move or remove
  // response remove, svelte legos can be implemented in the html element directly
  export function clickOutside(node) {
    const handleClick = event => {
      if (node && !node.contains(event.target) && !event.defaultPrevented) {
        node.dispatchEvent(new CustomEvent('click_outside', node));
      }
    };

    document.addEventListener('click', handleClick, true);

    return {
      destroy() {
        document.removeEventListener('click', handleClick, true);
      },
    };
  }
</script>

{#if show}
  <div class="modal" transition:fade>
    <div class="modal-body" bind:this={bodyElement}>
      <div
        class="modal-content"
        use:clickOutside
        on:click_outside={() => (show = false)}
      >
        <slot />
      </div>
    </div>
  </div>
{/if}

<style>
  .modal {
    width: 100%;
    height: 100%;
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    z-index: 1050;
    position: fixed;
    margin: 0 auto;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal-body {
    border-radius: 12px;
    background: transparent;
    min-height: 400px;
    margin: 20px;
  }

  .modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 30px 50px 30px;
  }
</style>
